import createAction from 'helpers/createAction';
import { SET_FILTERED_GEOJSON } from 'reducers/reducer';

const handleCropZoneRedirect = ({ geoJsonData, formActions, navigation }) => {
  const {
    createdCropZone,
    allFFTGeoJson,
    updateCropZoneGeoJson,
    dispatch
  } = geoJsonData;
  const { resetForm } = formActions;
  const { redirectToLanding, navigate } = navigation;

  // Add the saved crop zone to the landing's cached shapes, but only when the
  // cache holds them: after a reload it is empty, and seeding it with this crop
  // zone alone would stop the map refetching, dropping every other field.
  if (!redirectToLanding && allFFTGeoJson?.features?.length) {
    createAction(
      dispatch,
      SET_FILTERED_GEOJSON,
      updateCropZoneGeoJson(createdCropZone, allFFTGeoJson)
    );
  }

  resetForm();

  if (redirectToLanding) {
    navigate();
  }
};

export default handleCropZoneRedirect;
